import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { PagedResponse } from "../data/paged.response";
import { ServiceVacate } from "../data/service.vacate";
import { Resident } from "../../pages/resident/resident";
import { User } from "../data/users";
import { Vacate } from "../../pages/vacates/vacate";

@Injectable()
export class VacateService {
  constructor(private httpClient: HttpClient) {}

  public getAllResidents(date?) {
    if (date) {
      return this.httpClient.get<PagedResponse<Resident>>(
        `${environment.api_url}/api/residents`,
        {
          params: new HttpParams().set("date", date),
        }
      );
    } else {
      return this.httpClient.get<PagedResponse<Resident>>(
        `${environment.api_url}/api/residents`
      );
    }
  }

  public getUserInfo() {
    return this.httpClient.get<User>(`${environment.api_url}/api/organization`);
  }

  newVacate(createPayload: any) {
    // createPayload.forEach((value, key) => {
    //   console.log(`Key: ${key}, Value:`, value);
    // });
    return this.httpClient.post<any>(
      `${environment.api_url}/api/vacate-form`,
      createPayload
    );
  }

  updateVacate(id: string, updatePayload: FormData) {
    return this.httpClient.put<ServiceVacate>(
      `${environment.api_url}/api/vacate-form/${id}`,
      updatePayload
    );
  }

  findByResId(residentId: any) {
    return this.httpClient.get<PagedResponse<ServiceVacate>>(
      `${environment.api_url}/api/vacate-form/${residentId}`
    );
  }

  // findVacateAll() {
  //   return this.httpClient.get<PagedResponse<ServiceVacate>>(`${environment.api_url}/api/vacate-form`);
  // }

  findVacateAll(
    paginationData?: { page: number; size: number },
    sortBy?: any,
    sortDir?: any
  ) {
    let url = `${environment.api_url}/api/vacate-form`;

    if (paginationData) {
      url += `?page=${paginationData.page}&size=${paginationData.size}`;
    }
    if (sortBy) {
      url += `&sortBy=${sortBy}`;
    }
    if (sortDir) {
      url += `&sortDir=${sortDir}`;
    }

    return this.httpClient.get<PagedResponse<ServiceVacate>>(url);
  }

  delete(id: string) {
    return this.httpClient.delete(
      `${environment.api_url}/api/vacate-form/${id}`
    );
  }

  sendVacateEmail(payload) {
    return this.httpClient.post<PagedResponse<ServiceVacate>>(
      `${environment.api_url}/api/vacate-form-email/send`,
      payload
    );
  }

  deleteFileUser(vacateId: string, id: string) {
    return this.httpClient.delete(
      `${environment.api_url}/api/vacate-form/${vacateId}/documents/${id}`
    );
  }
}
